/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

export interface IClientClient {

    get(): Promise<Client>;
}

export class ClientClient implements IClientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Promise<Client> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Client> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Client>(null as any);
    }
}

export interface IDesignSelectionClient {

    postNextCard(designSelections: DesignSelections): Promise<DesignSelections>;

    postPreviousCard(designSelections: DesignSelections): Promise<DesignSelections>;

    postOptimise(designSelections: DesignSelections): Promise<DesignSelections>;
}

export class DesignSelectionClient implements IDesignSelectionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    postNextCard(designSelections: DesignSelections): Promise<DesignSelections> {
        let url_ = this.baseUrl + "/DesignSelection/next";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designSelections);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostNextCard(_response);
        });
    }

    protected processPostNextCard(response: Response): Promise<DesignSelections> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignSelections;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignSelections>(null as any);
    }

    postPreviousCard(designSelections: DesignSelections): Promise<DesignSelections> {
        let url_ = this.baseUrl + "/DesignSelection/previous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designSelections);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPreviousCard(_response);
        });
    }

    protected processPostPreviousCard(response: Response): Promise<DesignSelections> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignSelections;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignSelections>(null as any);
    }

    postOptimise(designSelections: DesignSelections): Promise<DesignSelections> {
        let url_ = this.baseUrl + "/DesignSelection/optimise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designSelections);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOptimise(_response);
        });
    }

    protected processPostOptimise(response: Response): Promise<DesignSelections> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignSelections;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignSelections>(null as any);
    }
}

export interface IEnumDescriptionClient {

    getCCTTemperatureType(enumValue: CCTTemperatureType | undefined): Promise<string>;

    getCCTType(enumValue: CCTType | undefined): Promise<string>;

    getBuildingType(enumValue: BuildingType | undefined): Promise<string>;

    getControlType(enumValue: ControlType | undefined): Promise<string>;

    getRecessedSize(enumValue: RecessedSizeType | undefined): Promise<string>;
}

export class EnumDescriptionClient implements IEnumDescriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getCCTTemperatureType(enumValue: CCTTemperatureType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/EnumDescription/CCTTemperatureType?";
        if (enumValue === null)
            throw new Error("The parameter 'enumValue' cannot be null.");
        else if (enumValue !== undefined)
            url_ += "enumValue=" + encodeURIComponent("" + enumValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCCTTemperatureType(_response);
        });
    }

    protected processGetCCTTemperatureType(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCCTType(enumValue: CCTType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/EnumDescription/CCTType?";
        if (enumValue === null)
            throw new Error("The parameter 'enumValue' cannot be null.");
        else if (enumValue !== undefined)
            url_ += "enumValue=" + encodeURIComponent("" + enumValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCCTType(_response);
        });
    }

    protected processGetCCTType(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getBuildingType(enumValue: BuildingType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/EnumDescription/BuildingType?";
        if (enumValue === null)
            throw new Error("The parameter 'enumValue' cannot be null.");
        else if (enumValue !== undefined)
            url_ += "enumValue=" + encodeURIComponent("" + enumValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBuildingType(_response);
        });
    }

    protected processGetBuildingType(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getControlType(enumValue: ControlType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/EnumDescription/ControlType?";
        if (enumValue === null)
            throw new Error("The parameter 'enumValue' cannot be null.");
        else if (enumValue !== undefined)
            url_ += "enumValue=" + encodeURIComponent("" + enumValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetControlType(_response);
        });
    }

    protected processGetControlType(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getRecessedSize(enumValue: RecessedSizeType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/EnumDescription/RecessedSizeType?";
        if (enumValue === null)
            throw new Error("The parameter 'enumValue' cannot be null.");
        else if (enumValue !== undefined)
            url_ += "enumValue=" + encodeURIComponent("" + enumValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecessedSize(_response);
        });
    }

    protected processGetRecessedSize(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPDFClient {

    generatePDF(designSelections: DesignSelections, emailAddress: string | null | undefined): Promise<void>;
}

export class PDFClient implements IPDFClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    generatePDF(designSelections: DesignSelections, emailAddress: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/PDF/generatePDF?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designSelections);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneratePDF(_response);
        });
    }

    protected processGeneratePDF(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectClient {

    getAll(): Promise<Project[]>;

    get(id: string | undefined): Promise<DesignSelections>;

    delete(id: string | undefined): Promise<void>;
}

export class ProjectClient implements IProjectClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Promise<Project[]> {
        let url_ = this.baseUrl + "/Project/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Project[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project[]>(null as any);
    }

    get(id: string | undefined): Promise<DesignSelections> {
        let url_ = this.baseUrl + "/Project/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<DesignSelections> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignSelections;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignSelections>(null as any);
    }

    delete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Project/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface Client {
    id: string;
    dateCreated: Date;
    dateUpdated?: Date | undefined;
    name?: string | undefined;
    domainName?: string | undefined;
    primaryColour?: string | undefined;
    secondaryColour?: string | undefined;
    tertiaryColour?: string | undefined;
    logoPath?: string | undefined;
}

export interface DesignSelections {
    languageType: LanguageType;
    projectName?: string | undefined;
    buildingType: BuildingType;
    commercialOfficeType: CommercialOfficeType;
    productType: ProductType;
    availableProductTypes?: ProductType[] | undefined;
    availableRecessedTypes?: RecessedSizeType[] | undefined;
    availableControlTypes?: ControlType[] | undefined;
    availableCCTTypes?: CCTType[] | undefined;
    availableColourTemperatures?: CCTTemperatureType[] | undefined;
    availableHousingColours?: HousingColourType[] | undefined;
    availableHousingFinishes?: HousingFinishType[] | undefined;
    recessedSizeType: RecessedSizeType;
    controlType: ControlType;
    cctType: CCTType;
    cctTemperatureType: CCTTemperatureType;
    cctDynamicType?: number[] | undefined;
    housingColourType: HousingColourType;
    housingFinishType: HousingFinishType;
    height: number;
    width: number;
    length: number;
    roomProperties?: RoomProperties | undefined;
    selection: CardType;
    atStart: boolean;
    atEnd: boolean;
    solutions?: ProjectResult[] | undefined;
    solution?: ProjectResult | undefined;
}

export enum LanguageType {
    None = "None",
    English = "English",
    French = "French",
    German = "German",
}

export enum BuildingType {
    None = "None",
    CommercialOffices = "CommercialOffices",
    Education = "Education",
    DomesticArea = "DomesticArea",
    Ancillary = "Ancillary",
    Warehouse = "Warehouse",
    Workshop = "Workshop",
    Hospitality = "Hospitality",
}

export enum CommercialOfficeType {
    None = "None",
    GeneralOffice = "GeneralOffice",
    ComputerWorkstation = "ComputerWorkstation",
    DrawingOffice = "DrawingOffice",
    PrintRoom = "PrintRoom",
    FilingArchiveRoom = "FilingArchiveRoom",
}

export enum ProductType {
    None = "None",
    Recessed = "Recessed",
    Surface = "Surface",
    Suspended = "Suspended",
    Downlights = "Downlights",
    Industrial = "Industrial",
}

export enum RecessedSizeType {
    None = "None",
    S600x600 = "s600x600",
    S1200x600 = "s1200x600",
    S1200x300 = "s1200x300",
}

export enum ControlType {
    None = "None",
    TrailingEdge = "TrailingEdge",
    LeadingEdge = "LeadingEdge",
    V1to10 = "v1to10",
    DALI = "DALI",
}

export enum CCTType {
    None = "None",
    Static = "Static",
    DynamicWhite = "DynamicWhite",
    WarmDimming = "WarmDimming",
}

export enum CCTTemperatureType {
    None = "None",
    K2700 = "K2700",
    K3000 = "K3000",
    K3500 = "K3500",
    K4000 = "K4000",
    K5000 = "K5000",
}

export enum HousingColourType {
    None = "None",
    White = "White",
    Black = "Black",
    Other = "Other",
}

export enum HousingFinishType {
    None = "None",
    Any = "Any",
    Aluminium = "Aluminium",
}

export interface RoomProperties {
    reflectanceCeiling: number;
    reflectanceWall: number;
    reflectanceFloor: number;
    targetIlluminance: number;
    ceilingDrop: number;
    workingPlaneHeight: number;
    maintenanceFactor: number;
}

export enum CardType {
    None = "None",
    LanguageType = "LanguageType",
    ProjectType = "ProjectType",
    BuildingType = "BuildingType",
    CommercialOfficeType = "CommercialOfficeType",
    ProductType = "ProductType",
    RecessedSizeType = "RecessedSizeType",
    ControlType = "ControlType",
    CCTType = "CCTType",
    CCTTemperatureType = "CCTTemperatureType",
    CCTDynamicType = "CCTDynamicType",
    HousingColourType = "HousingColourType",
    HousingFinishType = "HousingFinishType",
    RoomDimensionType = "RoomDimensionType",
    ResultsCard = "ResultsCard",
    ResultSelectionCard = "ResultSelectionCard",
}

export interface ProjectResult {
    id: string;
    dateCreated: Date;
    dateUpdated?: Date | undefined;
    projectInputId: string;
    projectInput?: ProjectInput | undefined;
    luminaireId: string;
    luminaire?: Luminaire | undefined;
    numberRequired: number;
    luxLevel: number;
    availability?: string | undefined;
    rowsRequired: number;
    columnsRequired: number;
    wattagePerArea: number;
    totalSchemeWatts: number;
    luminaireEfficacy: number;
}

export interface ProjectInput {
    id: string;
    dateCreated: Date;
    dateUpdated?: Date | undefined;
    projectId: string;
    project?: Project | undefined;
    buildingType: BuildingType;
    commercialOfficeType: CommercialOfficeType;
    luminaireProductType: ProductType;
    ceilingGridSize: RecessedSizeType;
    luminaireControlType: ControlType;
    luminaireCorrelatedColourTemperatureType: CCTType;
    luminaireColourTemperature: CCTTemperatureType;
    luminaireHousingColour: HousingColourType;
    luminaireHousingFinish: HousingFinishType;
    height: number;
    width: number;
    length: number;
    reflectanceCeiling: number;
    reflectanceWall: number;
    reflectanceFloor: number;
    targetIlluminance: number;
    ceilingDrop: number;
    workingPlaneHeight: number;
    maintenanceFactor: number;
}

export interface Project {
    id: string;
    dateCreated: Date;
    dateUpdated?: Date | undefined;
    deleted: boolean;
    projectName?: string | undefined;
}

export interface Luminaire {
    id: string;
    dateCreated: Date;
    dateUpdated?: Date | undefined;
    manufactureName?: string | undefined;
    luminaireName?: string | undefined;
    luminaireColourTemperature: CCTTemperatureType;
    luminaireColourType: CCTType;
    luminaireControlType: ControlType;
    luminaireHousingColour: HousingColourType;
    luminaireHousingFinish: HousingFinishType;
    luminaireRecessedSize: RecessedSizeType;
    luminaireProductType: ProductType;
    heightMM: number;
    widthMM: number;
    lengthMM: number;
    weightKG: number;
    deliveredLumens: number;
    ipRating?: string | undefined;
    ikRating?: string | undefined;
    mount?: string | undefined;
    driver?: string | undefined;
    uniformity: number;
    image1Path?: string | undefined;
    image2Path?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}